import { Text } from "../../FormControls/Text";
import { Fragment, useEffect, useState } from "react";
import { Box } from "../../FormControls/Box";
import { Stack } from "../../FormControls/Stack";
import { ScreenControl } from "../ScreenControl";
import { Button } from "../../FormControls/Button";
import status from "../../../assets/images/Success.png"
import {
  setPos,
  setProcedure,
  loginStore,
  setTokenStore,
  setGroup,
  setStoreName,
  setCountrySrore,
  setCurrencyStore,
  setMasterUser,
  setIdStore
} from "../../../../main/slices/storeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { ContentCopyOutlined } from "@mui/icons-material";
import { COLORS } from '../../../styles/defaults';
import { jump } from "../../../../main/slices/routerSlice";

export const SuccessStore = ({ dimensions }) => {
  const dispatch = useDispatch();
  let infoStatus = [];
  const state = useSelector(({ transaction }) => transaction);
  const userState = useSelector(({ user }) => user);
  const storeInfo = useSelector(({ store }) => store);
  const currentDate = new Date();
  const [cookies] = useCookies(["source"]);
  let textBtn = "Comenzar Ahora";
  
  // Opciones para formatear la fecha
  const options = {
    weekday: "long", // Día de la semana completo (martes)
    day: "2-digit", // Día con dos dígitos (10)
    month: "long", // Nombre completo del mes (diciembre)
    year: "numeric", // Año (2024)
    timeZone: "GMT", // Asegura que sea en GMT
  };
  // Formatear la fecha
  const dateFormat = currentDate.toLocaleDateString("es-ES", options);

  // COPY TEXT
  const [copySuccess, setCopySuccess] = useState(false);
  const textToCopy = "copiar";

  // const coupons = userState.paymentType.value === "COUPON";
  infoStatus = [
    { label: "Fecha", value: dateFormat },
    { label: "Código de Referencia", value: state.reference.value },
    { label: "DPI", value: userState.dpi.value },
    {
      label: "Monto",
      value: `${parseFloat(state.total.value).toFixed(2)} Quetzales`,
    }, // CONTEMPLAR RESTO DE MONEDAS LUEGO
  ];

  //AGREGAR AQUI LA LOGICA PARA EL USUARIO
  const jumpPage = async () => {
    return await dispatch(loginStore({
      "origin": "worldpos",
      "wldId": userState.idWLD,
      "pos": `${storeInfo.pos.value}`,
    }))
      .unwrap()
      .then(async ({ response }) => {
        
        if(response.code===200){
          let group= response.data.group;
          let pos= response.data.pos;
          let id= response.data.id;
          let name= response.data.name;
          let currency= response.data.currency;
          let country= response.data.country;
          let isMaster= response.data.master;

          //SETO LOS DATOS DE LA TIENDA
          dispatch(setPos({ value: pos, error: false }));
          dispatch(setMasterUser({ value: isMaster, error: false}))
          dispatch(setIdStore({ value: id, error: false }));
          dispatch(setGroup({value: group, error: false }));
          dispatch(setStoreName({ value: name, error: false }));
          dispatch(setCountrySrore({value: country, error: false }));
          dispatch(setCurrencyStore({ value: currency, error: false }));

          //MUESTRO PAD
          dispatch(jump({ current: 8, direction: "forward" }))
          return false;
        }else {
          //MUESTRO HOME
          dispatch(jump({ current: 0, direction: "forward" }))
          return false;
        };
      })
      .catch(e => {
        dispatch(jump({ current: 0, direction: "forward" }))
        return false;
      });
  };

  function copyText(text){
    if (navigator.clipboard) {
       const textToCopy = text.slice(1);//CAPTURA DESDE EL SEGUNDO CARACTER
      // Usamos la API de portapapeles
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          setCopySuccess(true); // Confirmamos que la copia fue exitosa
          setTimeout(() => setCopySuccess(false), 2000); // Reiniciamos el estado después de 2 segundos
        })
        .catch((err) => {
          console.error("Error al copiar al portapapeles: ", err);
          setCopySuccess(false); // Si hay un error, mostramos el mensaje
        });
    }
  }

  return (
    <Fragment>
      <div style={{ padding: "0 1.5rem" }}>
        <div style={{ marginBottom: "1rem" }}></div>
        {/* SCREEN LEGENDS */}
        
          <Stack flex={{ flexDirection: "Column" }}>
            <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <img
                    src={`${status}`}
                    alt="some alt"
                    loading="lazy"
                    style={{ maxWidth: "10em", margin: "-1.5em 0 1em 0" }}
                />
            </div>
            <Text
              classes={["tittle"]}
              style={{
                fontWeight: "bold",
                color: "#99b83c",
                alignItems: "center",
                textAlign: "center",
                fontSize: '1.25em'
              }}
            >
              {
                "¡Bienvenido a Recibe!"
              }
            </Text>
            <div style={{ marginBottom: "1rem" }}></div>
            <Text
              classes={["center"]}
              style={{
                fontSize: '0.8em'
              }}
            >
              {""}
                Tu comercio se ha registrado exitosamente, para iniciar sesión utiliza el comercio: 
              {""}
            </Text>
            <div style={{ marginBottom: "2rem" }}></div>
            <Text
              classes={["tittle", "center"]}
              style={{
                fontWeight: "bold",
                color: "rgba(108, 133, 137, 1)",
                alignItems: "center",
                textAlign: "center",
                fontSize: '2em'
              }}
            >
              {""}
                {storeInfo.pos.value}
              {""}
            </Text>
            <div style={{ marginBottom: "0.25rem" }}></div>
            <div style={{ display: "flex",  display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Button
                  style={{"color": COLORS.primary.font, "background": COLORS.primary.font}}
                  onClick={() => {copyText(storeInfo.pos.value)}}
              >
                  <Stack flex={{ flexDirection: "row", gap: 5 }}>
                      <ContentCopyOutlined  style={{"color": COLORS.primary.main}} fontSize="inherit" />
                      <Text 
                          style={{"color": COLORS.primary.main}}
                          classes={["description", "center"]} 
                      >
                          Copiar Comercio
                      </Text>
                  </Stack>
              </Button>
            </div>
            <div style={{ marginBottom: "2rem" }}></div>
            <Text
              classes={["center"]}
              style={{
                fontSize: '0.8em'
              }}
            >
              {""}
                Tambien hemos enviado un correo con tus credenciales para que puedas iniciar sesión en cualquier momento
              {""}
            </Text>
          </Stack>
        </div>
        <div style={{ marginBottom: "1rem" }}></div>
        <ScreenControl
          btnText={`${textBtn}`}
          beforeSubmit={() => jumpPage()}
          disabled={false} 
        ></ScreenControl>
    </Fragment>
  );
};
